import AIAnalytics from "../Faculty/AIAnalytics";
export default AIAnalytics;
